var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef, useState } from 'react';
export function useHover() {
    var nodeRef = useRef(null);
    var _a = __read(useState(false), 2), hovered = _a[0], setHovered = _a[1];
    useEffect(function () {
        var node = nodeRef.current;
        function handleMouseOver() {
            setHovered(true);
        }
        function handleMouseOut() {
            setHovered(false);
        }
        if (node) {
            node.addEventListener('mouseover', handleMouseOver);
            node.addEventListener('mouseout', handleMouseOut);
            return function () {
                node.removeEventListener('mouseover', handleMouseOver);
                node.removeEventListener('mouseout', handleMouseOut);
            };
        }
    }, [nodeRef.current]);
    return [nodeRef, hovered];
}
